import React from 'react'
import Tag from './Tag'

const Meta = props =>
  <Tag _name="meta" {...props} />

export default Meta
